import React, { useState } from "react";
// import { Table } from "@nextui-org/react";
import {
  Container,
  Card,
  Row,
  Col,
  Text,
  NextUIProvider
} from "@nextui-org/react";
import { Spacer, Button, Avatar } from "@nextui-org/react";
import { Grid } from "@nextui-org/react";
import { useNavigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

import { Table } from "@nextui-org/react";

export default function Cart() {
  const navigate = useNavigate();
  const location = useLocation();
  const details = location.state;

  React.useEffect(() => {
    if (
      Cookies.get("email") === undefined &&
      Cookies.get("password") === undefined
    )
      navigate("/login");
  }, []);

  return (
    <>
      <NextUIProvider>
        <Grid.Container gap={2}>
          <Spacer y={2} />
          <Row gap={2}>
            <Col>
              <Card
                bordered
                shadow={false}
                hoverable
                css={{ mw: "750px", margin: "auto" }}
                justify="center"
                height="1px"
              >
                <Text h1 align="center">
                  Your Cart{" "}
                </Text>
                <Spacer y={2} />
                <Table
                  aria-label="Example table with static content"
                  css={{
                    height: "auto",
                    minWidth: "100%"
                  }}
                >
                  <Table.Header>
                    <Table.Column> </Table.Column>
                    <Table.Column>Sl. No</Table.Column>
                    <Table.Column>Item Name</Table.Column>
                    <Table.Column>Number of Item</Table.Column>
                    <Table.Column>Price Per Item</Table.Column>
                    <Table.Column>Total Price</Table.Column>
                  </Table.Header>
                  <Table.Body>
                    {details.map((item, index) => (
                      <Table.Row key={index}>
                        <Table.Cell>
                          <Avatar
                            size="xs"
                            src={"https://nextui.org" + item.img}
                          />
                        </Table.Cell>
                        <Table.Cell>{index + 1}</Table.Cell>
                        <Table.Cell>{item.title}</Table.Cell>
                        <Table.Cell>{item.count}</Table.Cell>
                        <Table.Cell>${item.price}</Table.Cell>
                        <Table.Cell>${item.price * item.count}</Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              </Card>
            </Col>
            <Col>
              <Card
                bordered
                shadow={false}
                hoverable
                css={{ mw: "750px", margin: "auto" }}
                justify="center"
                height="1px"
              ></Card>
            </Col>
          </Row>
        </Grid.Container>
      </NextUIProvider>
      <Button
        bordered
        flat
        color="success"
        auto
        onClick={() => {
          navigate("/pay");
        }}
      >
        Pay
      </Button>
    </>
  );
}
